<div class="toast-stack" aria-live="polite" aria-atomic="true">
  @for (toast of toastService.toasts(); track toast.id) {
    <article class="toast-item panel-card border p-4 shadow-xl" [ngClass]="toneClass(toast.type)">
      <div class="flex items-start gap-3">
        <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl" [ngClass]="iconToneClass(toast.type)">
          <app-icon [name]="$any(iconName(toast.type))" className="h-5 w-5" />
        </div>
        <div class="min-w-0 flex-1">
          <p class="font-black">{{ toast.title }}</p>
          @if (toast.message) {
            <p class="mt-1 text-sm opacity-90">{{ toast.message }}</p>
          }
        </div>
        <button type="button" class="rounded-xl p-2 opacity-70 transition hover:bg-black/5 hover:opacity-100" (click)="toastService.dismiss(toast.id)" aria-label="Cerrar">
          <app-icon name="x" className="h-4 w-4" />
        </button>
      </div>
    </article>
  }
</div>
